import { useAutoAnimate } from "@formkit/auto-animate/react"
import React from "react"

interface InputProps {
	props?: any
	className?: string | null
	label?: string | null
	errMsg?: string
	hasError?: boolean
}

const ElemSelect: React.FC<InputProps> = ({ className, props, label, errMsg, hasError, children }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<>
			<label className={"relative block " + (className || "")}>
				{label && <div className={"font-AmsiRegular text-[16px]  pb-[6px] text-blue"}>{label}</div>}
				{children}

				<div ref={animationRef}>{hasError && <div className="formErrorMsg  js-formerror">{errMsg}</div>}</div>
			</label>
		</>
	)
}

export default ElemSelect
